import type {
  AdminBooking,
  BookingLifecycleStatus,
  BookingPaymentMethod,
} from '@mds/shared/types/booking';
import type {
  AdminPaymentListResponse,
  RecordManualPaymentRequest,
  RecordManualPaymentResponse,
} from '@mds/shared/types/payment';

import { api } from '@/lib/api';

/** The manual-payment ledger — see `backend/docs/payments.md`. */

/** A type alias, so it carries the index signature the client's `query` needs. */
export type PaymentQuery = {
  page?: number;
  limit?: number;
  /** Matched across the `PM-` reference, the `SB-` reference and customer name. */
  search?: string;
  method?: BookingPaymentMethod;
  /** Applies to the rows and the summary alike. */
  bookingStatus?: BookingLifecycleStatus;
  sort?: 'recordedAt' | 'amountMinor' | 'reference' | 'customerName';
  direction?: 'asc' | 'desc';
};

/** Rows plus the summary totals for the same filter, counted by the server. */
export const listPayments = (query: PaymentQuery = {}) =>
  api.get<AdminPaymentListResponse>('admin/payments', { query });

/**
 * Records a payment against a booking named by id or `SB-` reference.
 *
 * The response is the whole updated booking, not the payment row: totals,
 * balance and lifecycle all move with it.
 */
export const recordManualPayment = (body: RecordManualPaymentRequest): Promise<AdminBooking> =>
  api.post<RecordManualPaymentResponse>('admin/payments', body).then((r) => r.data);
